"use client"

import { cn } from "@/lib/utils"

import { useSearch } from "@/hooks/use-search"
import FeaturesFilter from "./features-filter"
import OtherFilters from "./other-filters"
import TechnologiesFilter from "./technologies-filter"

export default function SecondaryNavbar() {
  const { filter } = useSearch();

  const isMobile = typeof window !== "undefined" && window.innerWidth <= 1024;

  return (
    <div className="hidden h-full w-[290px] shrink-0 overflow-y-auto scroll-smooth bg-main-bg lg:block">
      <div
        className={cn(
          "flex h-full w-full justify-between border-r border-neutral-200 bg-main-bg p-[20px] xl:flex-col"
        )}
      >
        {filter === "Technologies" ? (
          <TechnologiesFilter />
        ) : filter === "Features" ? (
          <FeaturesFilter />
        ) : filter === "Other filters" ? (
          <OtherFilters />
        ) : isMobile ? (
          <></>
        ) : (
          <TechnologiesFilter />
        )}
      </div>
    </div>
  )
}
